<!--
  The event's poster: one portrait image, shown whole beside the title.
  While editing it is the same image reference as on the panorama, with the
  way to more images on it — a second image turns the poster into a panorama.
-->
<script>
  import ZoomableImage from '#lib/ZoomableImage.svelte';
  import ImageRef from '#lib/ImageRef.svelte';
  import EntrySelectorDrawer from '#lib/EntrySelectorDrawer.svelte';
  import t from '#lib/i18n.svelte.js';
  import '#lib/system-styles/event-ui.css';

  let {
    /** The resolved image entry */
    image,
    images_multiref = $bindable([]),
    is_editing = false,
    /** Called with the index of the removed reference */
    onremove,
    /** Called with the entry ids to add */
    onadd,
  } = $props();
</script>

<div class='event-poster' style:--poster-ratio={image ? image.width / image.height : undefined}>
  {#if is_editing}
    <ImageRef
      {is_editing}
      bind:image_ref={images_multiref[0]}
      {image}
      selected_entry_ids={images_multiref}
      onremove={() => onremove?.(0)}
    />
    <div class='event-poster-add'>
      <EntrySelectorDrawer
        entry_type='image'
        excluded_ids={images_multiref.filter(Boolean)}
        label={t('browse_images')}
        icon='image'
        variant='brand encased'
        multi_select={true}
        confirm_label={t('add_selected_entry')}
        confirm_label_plural={t('add_selected_entries', { count: '{{count}}' })}
        onconfirm={onadd}
      />
    </div>
  {:else if image}
    <!-- The first thing on the page: loaded right away -->
    <ZoomableImage {...image} sizes='(min-width: 768px) 30vw, 100vw' loading='eager' />
  {/if}
</div>
